import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    VendorsServiceProxy,
    CreateOrEditVendorDto,
    DropDownLookupDto,
    CommonLookupServiceProxy,
    VendorChartOfAccountLookupTableDto,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    templateUrl: './create-or-edit-vendor.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditVendorComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;

    vendor: CreateOrEditVendorDto = new CreateOrEditVendorDto();

    paymentTermName = '';
    currencyName = '';
    locationName = '';
    chartOfAccountDisplayProperty = '';

    allPaymentTerms: DropDownLookupDto[];
    allCurrencys: DropDownLookupDto[];
    allLocations: DropDownLookupDto[];
    allChartOfAccounts: VendorChartOfAccountLookupTableDto[];

    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('Vendor'), '/app/purchase/vendors'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _vendorsServiceProxy: VendorsServiceProxy,
        private _commonLookupService: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
    }

    show(vendorId?: number): void {
        if (!vendorId) {
            this.vendor = new CreateOrEditVendorDto();
            this.vendor.id = vendorId;
            this.paymentTermName = '';
            this.currencyName = '';
            this.locationName = '';
            this.chartOfAccountDisplayProperty = '';

            this.active = true;
        } else {
            this._vendorsServiceProxy.getVendorForEdit(vendorId).subscribe((result) => {
                this.vendor = result.vendor;

                this.paymentTermName = result.paymentTermName;
                this.currencyName = result.currencyName;
                this.locationName = result.locationName;
                this.chartOfAccountDisplayProperty = result.chartOfAccountDisplayProperty;

                this.active = true;
            });
        }
        this._commonLookupService.getAllPaymentTermForTableDropdown().subscribe((result) => {
            this.allPaymentTerms = result;
        });
        this._commonLookupService.getAllCurrencyForTableDropdown().subscribe((result) => {
            this.allCurrencys = result;
        });
        this._commonLookupService.getAllLocationForTableDropdown().subscribe((result) => {
            this.allLocations = result;
        });
        this._commonLookupService.getAllChartOfAccountForTableDropdown().subscribe((result) => {
            this.allChartOfAccounts = result;
        });
    }

    save(): void {
        this.saving = true;

        this._vendorsServiceProxy
            .createOrEdit(this.vendor)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/purchase/vendors']);
            });
    }

    saveAndNew(): void {
        this.saving = true;

        this._vendorsServiceProxy
            .createOrEdit(this.vendor)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.vendor = new CreateOrEditVendorDto();
            });
    }
        goBack(): void {
        this._router.navigate(['/app/purchase/vendors']);
    }
}
